// ClientSettings table → row.libelle / row.value / row.min / row.max / row.unit / row.dataType / row.code / row.id
export const CLIENT_SETTINGS = [
  { id: 'cs-1', code: 'client_language', libelle: 'Default language', value: 'en', min: null, max: null, unit: null, dataType: 'java.lang.String' },
  { id: 'cs-2', code: 'session_timeout', libelle: 'Session timeout', value: '30', min: '5', max: '120', unit: 'min', dataType: 'java.lang.Integer' },
  { id: 'cs-3', code: 'password_min_length', libelle: 'Password minimum length', value: '14', min: '8', max: '64', unit: 'chars', dataType: 'java.lang.Integer' },
  { id: 'cs-4', code: 'password_history', libelle: 'Password history (last N)', value: '12', min: '1', max: '24', unit: 'pwd', dataType: 'java.lang.Integer' },
  { id: 'cs-5', code: 'mfa_required', libelle: 'MFA required for LEVEL_3', value: 'true', min: null, max: null, unit: null, dataType: 'java.lang.String' },
  { id: 'cs-6', code: 'audit_retention_days', libelle: 'Audit log retention', value: '730', min: '90', max: '3650', unit: 'days', dataType: 'java.lang.Integer' },
  { id: 'cs-7', code: 'lockout_threshold', libelle: 'Login lockout threshold', value: '5', min: '3', max: '10', unit: 'tries', dataType: 'java.lang.Integer' },
];

// EmailContent uses .subject and .template (HTML body). Looked up via code + language (uppercase).
export const EMAIL_TEMPLATES = [
  {
    id: 'tpl-1',
    code: 'ack-cvn',
    language: 'EN',
    subject: 'Please acknowledge your access convention',
    template: '<p>Dear {{firstName}},</p><p>You have been granted access under convention <b>{{conventionName}}</b>. Please review and acknowledge.</p>',
  },
  {
    id: 'tpl-2',
    code: 'ack-cvn',
    language: 'FR',
    subject: 'Veuillez accuser réception de votre convention',
    template: '<p>Bonjour {{firstName}},</p><p>Un accès vous est attribué dans le cadre de la convention <b>{{conventionName}}</b>. Merci de bien vouloir l\'accuser réception.</p>',
  },
  {
    id: 'tpl-3',
    code: 'renew-expired-convention',
    language: 'EN',
    subject: 'Your convention is about to expire',
    template: '<p>Hello {{firstName}},</p><p>Your convention <b>{{conventionName}}</b> expires on {{expirationDate}}.</p>',
  },
  {
    id: 'tpl-4',
    code: 'renew-expired-convention',
    language: 'FR',
    subject: 'Votre convention arrive à expiration',
    template: '<p>Bonjour {{firstName}},</p><p>Votre convention <b>{{conventionName}}</b> expire le {{expirationDate}}.</p>',
  },
  {
    id: 'tpl-5',
    code: 'renew-saturated-convention',
    language: 'EN',
    subject: 'Convention usage threshold reached',
    template: '<p>Hello,</p><p>Convention <b>{{conventionName}}</b> reached usage threshold.</p>',
  },
  {
    id: 'tpl-6',
    code: 'renew-saturated-convention',
    language: 'FR',
    subject: 'Convention saturée — renouvellement nécessaire',
    template: '<p>Bonjour,</p><p>La convention <b>{{conventionName}}</b> a atteint son seuil d\'utilisation.</p>',
  },
];

// AlertSettings table → row.libelle / row.value / row.min / row.max / row.unit / row.description / row.id
export const ALERT_SETTINGS = [
  { id: 'as-1', code: 'failed_login_threshold', libelle: 'Failed logins triggering an alert', value: '5', min: '1', max: '100', unit: 'tries', description: 'Triggers a PENDING alert when reached.' },
  { id: 'as-2', code: 'volume_anomaly_pct', libelle: 'Volume deviation threshold', value: '25', min: '5', max: '90', unit: '%', description: 'Percent deviation vs 30-day moving average.' },
  { id: 'as-3', code: 'saturation_threshold_pct', libelle: 'Convention saturation threshold', value: '90', min: '50', max: '99', unit: '%', description: 'Triggers a renew-saturated mail.' },
  { id: 'as-4', code: 'expiry_warning_days', libelle: 'Convention expiry warning', value: '30', min: '1', max: '180', unit: 'days', description: 'Days before expiration to notify users.' },
  { id: 'as-5', code: 'inactive_account_days', libelle: 'Inactive account alert', value: '90', min: '7', max: '365', unit: 'days', description: 'Days of inactivity before raising an alert.' },
];
